import axios from 'axios';

const basePath = '/api/resource_portal/booking_slots';

const slotsApi = {
  fetchSlots(params) {
    return axios({
      method: 'get',
      url: `${basePath}`,
      params,
    });
  },
  fetchSlot(params) {
    return axios({
      method: 'get',
      url: `${basePath}/${params.slotId}`,
      params,
    });
  },
  cancelSlot(params) {
    return axios({
      method: 'post',
      url: `${basePath}/${params.slotId}/cancel`,
      params,
    });
  },
};

export default slotsApi;
